import { ThemeColor, TypographyVariants } from '@/enums'
import { noop, openHubspotChat } from '@/utils'
import { useTranslation } from 'react-i18next'
import { config } from '../../../config'
import { Typography } from '../../atoms/Typography'
import { Column, Row } from '../../styled'
import {
  Container,
  Header,
  Section,
  StyledButton,
  StyledImage,
  StyledLink,
} from './styles'

export interface ContactInfoProps {
  title?: string
  subtitle?: string
  showAvailableBtn?: boolean
  hasHeadquarters?: boolean
  onClose?: () => void
  photo?: string
  rowHeader?: boolean
  withGap?: boolean
  titleSize?: keyof typeof TypographyVariants
  subtitleSize?: keyof typeof TypographyVariants
  hide?: {
    chat?: boolean
    header?: boolean
  }
}

const useMessages = () => {
  const { t } = useTranslation()

  return {
    call: t('call'),
    liveChat: t('liveChat'),
    email: t('contactModalEmail'),
    available: t('available'),
    availableNow: t('availableNow'),
  }
}

export const ContactInfo: React.FC<ContactInfoProps> = ({
  title,
  subtitle,
  showAvailableBtn,
  hasHeadquarters,
  onClose = noop,
  photo,
  rowHeader,
  withGap,
  titleSize,
  subtitleSize,
  hide = {},
}) => {
  const messages = useMessages()

  const configPhone = hasHeadquarters
    ? config.midMarketPhone
    : config.contactPhone

  return (
    <Container withGap={withGap}>
      {!hide.header && (
        <Header rowHeader={rowHeader}>
          <Row justifyContent="space-between">
            {photo && <StyledImage name={photo} type="png" />}
            {showAvailableBtn && (
              <StyledButton
                color={ThemeColor.success2}
                onClick={openHubspotChat}
                size="medium"
              >
                {messages.availableNow}
              </StyledButton>
            )}
          </Row>
          {(title || subtitle) && (
            <Column gap={rowHeader ? '4px' : '8px'}>
              <Typography variant={titleSize || 'h4'}>{title}</Typography>
              <Typography
                color={ThemeColor.b50}
                variant={subtitleSize || 'p1Body'}
              >
                {subtitle}
              </Typography>
            </Column>
          )}
        </Header>
      )}
      <Column>
        <StyledLink href={`tel: ${configPhone}`}>
          <Section>
            <Typography variant="captionB">{messages.call}</Typography>
            <Typography color={ThemeColor.b50} variant="p1Body">
              {configPhone}
            </Typography>
          </Section>
        </StyledLink>
        {/* Todo: This section needs to be removed */}
        {!hide.chat && (
          <Section
            onClick={() => {
              onClose()
              openHubspotChat()
            }}
          >
            <Typography variant="captionB">{messages.liveChat}</Typography>
            <Typography color={ThemeColor.success2} variant="p1Body">
              {messages.available}
            </Typography>
          </Section>
        )}
        <StyledLink href={`mailto: ${config.contactEmail}`}>
          <Section>
            <Typography variant="captionB">{messages.email}</Typography>
            <Typography color={ThemeColor.b50} variant="p1Body">
              {config.contactEmail}
            </Typography>
          </Section>
        </StyledLink>
      </Column>
    </Container>
  )
}
